import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-3xl shadow-sm p-8 text-center" data-testid="payment-cancel-page">
        <div className="w-16 h-16 rounded-full bg-slate-100 text-slate-500 flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-9 h-9" />
        </div>
        <h1 className="text-2xl font-black text-[#1d3d3a]">Pagamento annullato</h1>
        <p className="text-slate-600 mt-2 text-sm">
          Nessun addebito effettuato. Puoi riprovare quando vuoi dal tuo profilo.
        </p>
        <div className="mt-6 flex flex-col gap-2">
          <Button onClick={() => navigate("/profilo")} className="bg-[#e86a24] hover:bg-[#c8561a] rounded-full">
            Torna al profilo
          </Button>
          <Button variant="outline" onClick={() => navigate("/")} className="rounded-full">
            Vai alla home
          </Button>
        </div>
      </div>
    </div>
  );
}
